import type { AnchorHTMLAttributes, ComponentType } from 'react';

/**
 * Router-agnostic link contract for @slims-pro/ui. The library must not depend on a
 * specific framework router (Next/React Router), so components accept a
 * `linkComponent` of this shape and default to {@link NativeLink}. Consumers
 * inject their router's link (e.g. a React Router adapter) for client-side nav.
 * `href` is required; all other anchor attributes (title, target, …) pass through.
 */
export interface LinkLikeProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	href: string;
}

export type LinkLike = ComponentType<LinkLikeProps>;

/** Default: a plain anchor (full navigation). */
export const NativeLink: LinkLike = ({ href, children, ...rest }) => (
	<a href={href} {...rest}>
		{children}
	</a>
);
